import { combineReducers, configureStore } from "@reduxjs/toolkit";
import userReducer from "./reducers/userSlice.js";
import cartReducer from "./reducers/cartSlice";
import notificationReducer from "./reducers/notificationSlice";
import productReducer from "./reducers/productSlice";
import filterReducer from "./reducers/filterSlice";
import adminReducer from "./reducers/adminSlice";
import thunk from 'redux-thunk';

const rootReducer = combineReducers({
	filter: filterReducer,
	user: userReducer,
	cart: cartReducer,
	notification: notificationReducer,
	product: productReducer,
	admin: adminReducer,
});

const store = configureStore({
	reducer: rootReducer,
	middleware: [thunk],
});

export default store;

